import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default {
  exact: true,
  path: '/home/operated/VcConfigure',
  owner: '/home',
  authority: 'VcConfigEdit',
  component: Loadable({
    loader: () => import('./index'),
    loading: () => <RouteLoading />
  })
};